import * as React from 'react';

import { Box, Typography } from '@mui/material';

import { StepDefinition, StepId } from '../model/steps';
import styles from '../ReportRequestV2.module.css';

export const sectionElementId = (id: StepId) => `report-section-${id}`;

interface Props {
  step: StepDefinition;
  invalid: boolean;
  children: React.ReactNode;
}

/** One former wizard step, rendered as a titled block of the single-page form. */
const FormStepSection: React.FC<Props> = ({ step, invalid, children }) => {
  const id = sectionElementId(step.id);
  return (
    <Box
      component="section"
      id={id}
      aria-labelledby={`${id}-title`}
      className={styles.section}
    >
      <Box className={styles.sectionHeader}>
        <Typography
          id={`${id}-title`}
          variant="h6"
          component="h2"
          color={invalid ? 'error' : undefined}
        >
          {step.label}
        </Typography>
        {step.description && (
          <Typography variant="body2" color="text.secondary">
            {step.description}
          </Typography>
        )}
      </Box>
      {children}
    </Box>
  );
};

export default FormStepSection;
